module.exports = __webpack_public_path__ + "static/media/logout.623ae221.svg";